import styled from 'styled-components';

import { Checkbox } from '../styled';

export const Content = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`;

export const StyledCheckbox = styled(Checkbox)`
  input,
  label {
    cursor: pointer;
  }
  &.checkbox {
    input {
      border: 1px solid #fff;
    }
  }
`;
export const InputBox = styled.div`
  position: relative;
  height: 100%;
  &:after {
    content: '';
    position: absolute;
    top: 12px;
    right: 5px;
    width: 6px;
    height: 6px;
    border: 2px solid #bebebe;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
  input {
    text-overflow: ellipsis;
    padding-right: 20px;
    max-width: 393px;
  }
`;
